import { LatLngBounds } from 'leaflet';
import pointInPolygon from 'point-in-polygon';

export interface GeoQueryBounds {
    neLat: number;
    neLng: number;
    swLat: number;
    swLng: number;
}

export function leafletBoundsToQueryVariables(bounds: LatLngBounds): GeoQueryBounds {
    const { lat: neLat, lng: neLng } = bounds.getNorthEast();
    const { lat: swLat, lng: swLng } = bounds.getSouthWest();
    return {
        neLat,
        neLng,
        swLat,
        swLng,
    };
}

export function lassoResultToQueryVariables(result: L.LatLng[]): GeoQueryBounds {
    const { lats, lons } = result.reduce((out, { lat, lng}) => ({
        lats: [...out.lats, lat],
        lons: [...out.lons, lng],
    }), { lats: [], lons: [] } as {
        lats: number[],
        lons: number[]
    });
    const maxLon = Math.max(...lons);
    const minLon = Math.min(...lons);
    const maxLat = Math.max(...lats);
    const minLat = Math.min(...lats);

    return {
        neLat: maxLat,
        neLng: maxLon,
        swLat: minLat,
        swLng: minLon,
    };
}

export function boundsToQueryGeoPoly(bounds: LatLngBounds) {
    const { lat: neLat, lng: neLng } = bounds.getNorthEast();
    const { lat: swLat, lng: swLng } = bounds.getSouthWest();
    return {
        type: 'Polygon',
        coordinates: [
            [
                [swLng, swLat],
                [neLng, swLat],
                [neLng, neLat],
                [swLng, neLat],
                [swLng, swLat],
            ],
        ],
        crs: 4326,
    };
}

export function lassoResultToGeoPoly(result: L.LatLng[]) {
    const { lats, lons } = result.reduce((out, { lat, lng}) => ({
        lats: [...out.lats, lat],
        lons: [...out.lons, lng],
    }), { lats: [], lons: [] } as {
        lats: number[],
        lons: number[]
    });
    const maxLon = Math.max(...lons);
    const minLon = Math.min(...lons);
    const maxLat = Math.max(...lats);
    const minLat = Math.min(...lats);
    return {
        type: 'Polygon',
        coordinates: [
            [
                [maxLon, maxLat],
                [minLon, maxLat],
                [minLon, minLat],
                [maxLon, minLat],
                [maxLon, maxLat],
            ],],
        crs: 4326,
    }
}

export function filterQueryForLasso({ latitude, longitude }: { latitude: number, longitude: number }, lassoResult: L.LatLng[]) {
    return pointInPolygon([latitude, longitude], [
        ...lassoResult.map(({ lat, lng }) => [lat, lng]),
        [lassoResult[0].lat, lassoResult[0].lng]
    ]);
}

export function calculateMinimumCityCount(zoom: number) {
    const cutoffs = [10_000_000, 5_000_000, 1_000_000, 200_000];
    return zoom <= 5 ? cutoffs[0] : cutoffs[zoom - 5] || 100000;
}

